import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Provider } from '@aid/administration/types/classes/provider.class';

@Component({
  selector: 'aid-providers-table',
  template: `
    <mat-card
      class="table-wrapper full-width flex full-height aid-layout-column"
    >
      <div class="full-width padding-vertical-16">
        <aid-search
          [searchPlaceholder]="'providers'"
          (search)="onSearch($event)"
        ></aid-search>
      </div>

      <mat-divider class="table-wrapper__divider"></mat-divider>
      <div class="table">
        @for (type of providers; track type) {
          <div
            class="table__element aid-layout-row aid-layout-align-start-center"
            [ngClass]="{ 'table__element--clicked': isSelectedRow(type) }"
          >
            <aid-card-item
              class="full-width"
              [name]="type.name"
              [selected]="isSelectedRow(type)"
              (select)="onSelectRow(type)"
            ></aid-card-item>
          </div>
        }

        @if (!isProviders) {
          <div
            class="full-width mat-body table__element--color padding-64 aid-layout-row aid-layout-align-center-start"
          >
            {{ 'there-are-no-providers' | translate }}
          </div>
        }
      </div>
    </mat-card>
  `,
  styleUrls: ['./providers-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ProvidersTableComponent implements OnInit {
  @Input() providers?: Provider[] | null;
  @Input() selectedRow?: number | null;

  @Output() select = new EventEmitter();
  @Output() search: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}

  onSelectRow(element: Provider) {
    this.select.emit(element);
  }

  get isProviders() {
    return this.providers && this.providers.length > 0;
  }

  isSelectedRow(type: Provider) {
    return type.id === this.selectedRow;
  }

  onSearch(search: string) {
    this.search.emit(search);
  }
}
